export const setOrganisationsIds = ids => {
  return `${encodeURIComponent('organizations')}=${encodeURIComponent(ids)}`
}
